import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
export function formatTime(totalSeconds: number) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}
export function useCallTimer() {
  const $ = _c(4);
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerInterval = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (timerInterval.current) {
        clearInterval(timerInterval.current);
      }
      setElapsedTime(0);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const stopTimer = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      stopTimer();
      const startTime = Date.now();
      timerInterval.current = setInterval(() => {
        const currentTime = Date.now();
        const differenceInSeconds = Math.floor((currentTime - startTime) / 1000);
        setElapsedTime(differenceInSeconds);
      }, 1000);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const startTimer = t1;
  let t2;
  if ($[2] !== elapsedTime) {
    t2 = {
      elapsedTime,
      startTimer,
      stopTimer,
      timerInterval
    };
    $[2] = elapsedTime;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}